import LockedFeature from 'components/generic/LockedFeature'
import PlayerLevelTable from '../player-level/player-level-table/PlayerLevelTable'
import { Player } from 'types/global'

const blurredPlayer = {
  demographicStats: [
    {
      strata: [{ attribute: 'Age', label: 'Unknown' }],
      percentileBounds: [20, 30],
      stratumSize: 84148,
    },
    {
      strata: [{ attribute: 'Sex', label: 'F' }],
      percentileBounds: [50, 60],
      stratumSize: 1345562,
    },
    {
      strata: [{ attribute: 'Country', label: 'Unknown' }],
      percentileBounds: [60, 70],
      stratumSize: 492001,
    },
  ],
  isVerifiedSingles: true,
}

const BlurredPlayerLevel = () => (
  <LockedFeature info={{ ns: 'strMessageScreen', transKey: 'lockedFeature.blurredPlayerLevels' }}>
    <PlayerLevelTable profile={blurredPlayer as unknown as Player} />
  </LockedFeature>
)

export default BlurredPlayerLevel
